import React, { useState } from 'react';
// @ts-ignore
import styles from './ECardFilesAccessCheck.module.scss';
import Text from '../../../../Components/Base/Text/Text';
import { useEffectAsync } from '../../../../helpers';
import useApiClient from '../../../Base/Hooks/useApiClient';
import apiClient from '../../../../Services/ApiClient';
import Tooltip from '../../../../Components/Popup/Tooltip';

interface Props {
	patientId: string;
}

const ECardFilesAccessCheck: React.FC<Props> = ({ patientId }) => {
	const { displayError } = useApiClient();
	const [isNotRestricted, setIsNotRestricted] = useState(false);

	useEffectAsync(async () => {
		try {
			const result = await apiClient.get(
				`/user/${patientId}/documentation/check-system-status`,
			);
			if (result?.data?.canViewAllSystemFolders) {
				setIsNotRestricted(result?.data?.canViewAllSystemFolders);
			}
		} catch (e) {
			displayError(e);
		}
	}, []);

	if (!isNotRestricted) {
		return (
			<div className={styles.wrapper}>
				<Text tx='component.eCardFilesAccessCheck.warningMessage' />
				<Tooltip
					trigger={
						<img
							alt={'info'}
							className='ml-2'
							width='20px'
							src='/dist/icons/v2/circle-info-solid.svg'
						/>
					}>
					<Text tx='component.eCardFilesAccessCheck.tooltip' inline={true} />
				</Tooltip>
			</div>
		);
	}

	return <></>;
};

export default ECardFilesAccessCheck;
